import { render, staticRenderFns } from "./AppointmentTransportationCoordinationReport.vue?vue&type=template&id=e5036bf2&"
import script from "./AppointmentTransportationCoordinationReport.vue?vue&type=script&lang=ts&"
export * from "./AppointmentTransportationCoordinationReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports